import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';
import * as defaults from '../../store-defaults';

export default {
    state: {
        appName: 'default',
        user: null,
        loading: true,
        errors: [],
        storageDir: '',
        selected_user: '',
        baseURL: defaults.BASE_URL,
    },
    getters,
    mutations,
    actions
}